import type { ILink } from "src/interfaces/Link";

export const getBackLabel = (from: string | undefined, review?: boolean) => {
  if (review) return "Back to Review";
  if (from?.startsWith("/logbook/")) return "Back to Entry";
  if (from?.startsWith("/summary")) return "Back to Summary";
  return "Back";
};

export const addLogbookCrumb = (
  links: ILink[],
  from: string | undefined,
  lbname: string | undefined,
  goBack?: () => void,
): ILink[] => {
  if (!from?.startsWith("/logbook/") || !lbname) return links;
  return [
    ...links.slice(0, -1),
    {
      title: lbname,
      href: from,
      ...(goBack && {
        onClick: e => {
          e.preventDefault();
          goBack();
        },
      }),
    },
    ...links.slice(-1),
  ];
};
